const mutations = {
    SET_ERROR_CARTS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
